export enum ETipoTelefone {
    Celular = 1,
    Fixo = 2,
    WhatsApp = 3,
    Telegram = 4,
}
